import { Controller } from "@hotwired/stimulus"
import { qrcanvas } from 'qrcanvas'

export default class extends Controller {
  static values = {
    url: String
  }
  connect() {
    // QRCode.toCanvas(canvas, this.urlValue, function (error) {
    //   if (error) console.error(error)
    //   console.log('success!');
    // })
    const canvas = qrcanvas({
      data: this.urlValue,
      size: 200,
      resize: true
    })
    this.element.prepend(canvas)
  }
}
